import { createFileRoute } from "@tanstack/react-router";
import { enPhotoRoute } from "@/lib/seo/enPhotoRoute";

export const Route = createFileRoute("/en_/photography/gothenburg")(
  enPhotoRoute("/en/photography/gothenburg"),
);
